export default __webpack_public_path__ + "static/media/kia.d5787553.png";